import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
  Fab,
} from "@material-ui/core";
import DeliveriesTable from "./DeliveriesTable";
import AddIcon from "@material-ui/icons/Add";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useDeliveryData } from "../../../data/clearing/delivery/hooks/useDeliveryData";
import { useDeliveryIndex } from "../../../data/clearing/delivery/hooks/useDeliveryIndex";
import { useHistory } from "react-router-dom";
import { getDeliveriesEditLocation } from "../delivery/Locations";
import { PageDataStatus } from "../../../data/models";
import { DeliveryFilterButton } from "./DeliveryFilter";
import { useAuth } from "../../../data/auth/hooks";
import { DownloadDeliveryButton, DownloadDeliveryButtonExcel } from "./DownloadDeliveryButton";

const DeliveriesPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [pageData, dispatchLoadDelivery] = useDeliveryData();
  const [pageIndex, dispatchSetIndex] = useDeliveryIndex();

  React.useEffect(() => {
    if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
      dispatchLoadDelivery();
    }
  }, [dispatchLoadDelivery, pageData]);

  const history = useHistory();

  const [auth] = useAuth();

  if (auth.status !== "successful") {
    return null;
  }

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="dlvrDiliveryTitle" />}
              action={<DeliveryAction />}
            />
            <Divider />
            <CardContent>
              <DeliveriesTable
                pageIndex={pageIndex}
                pageData={pageData}
                onPageIndexChange={dispatchSetIndex}
                userAccessRights={userAccessRights}
                getData={dispatchLoadDelivery}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const DeliveryAction: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <DownloadDeliveryButton />
    </Grid>
    <Grid item>
      <DownloadDeliveryButtonExcel />
    </Grid>
    <Grid item>
      <DeliveryFilterButton />
    </Grid>
  </Grid>
);

export default DeliveriesPage;

